import i18n from '../../../i18n';

const INSTAGRAM_UPLOAD_SUBCODES = /\b2018007\b|\b2018047\b/;
const INSTAGRAM_GRAPH_JSON = /"type"\s*:\s*"(?:IGApiException|OAuthException)"/i;
const INSTAGRAM_UPLOAD_MESSAGE = /upload(?:en)? mislukt|upload failed|upload attachment failure/i;

export const formatExternalChannelSendError = (message: string | null | undefined, fallback: string): string => {
  const raw = message?.trim() ?? '';
  if (!raw) {
    return fallback;
  }

  const looksLikeGraphJson = raw.startsWith('{') && INSTAGRAM_GRAPH_JSON.test(raw);
  if (INSTAGRAM_UPLOAD_SUBCODES.test(raw) || (looksLikeGraphJson && INSTAGRAM_UPLOAD_MESSAGE.test(raw))) {
    return i18n.t('instagramUploadFailed', { ns: 'conversations', defaultValue: fallback });
  }

  if (looksLikeGraphJson) {
    return i18n.t('instagramSendFailed', { ns: 'conversations', defaultValue: fallback });
  }

  return raw;
};
